import React, { useState } from "react";
const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
  console.error("REACT_APP_API_URL is not defined in .env");
}
export default function SubmitRequest({ onSubmit }) {

const projectGroupsMap = {
  "U2Innovate Project-1: AI Chatbot Development": [
    "Group 1",
     "Group 2",
      "Group 3",
       "Group 4",
    "Group 5",
    "Group 116",
    "Group 117"
  ],

  "U2Innovate Project-2: Cyber Security Dashboard": [
    "Group 6",
    "Group 7",
    "Group 8",
    "Group 9",
    "Group 10",
    "Group 118",
    "Group 119"
  ],

  "U2Innovate Project-3: AI-Based Student Performance Prediction": [
    "Group 11",
    "Group 12",
    "Group 13",
    "Group 14",
    "Group 15",
    "Group 120",
    "Group 121"
  ],

  "U2Innovate Project-4: Explainable AI for Healthcare Diagnosis": [
    "Group 16",
    "Group 17",
    "Group 18",
    "Group 19",
    "Group 20",
    "Group 122",
    "Group 123"
  ],

  "U2Innovate Project-5: AI Powered Fake News Detection": [
     "Group 21",
    "Group 22",
    "Group 23",
    "Group 24",
    "Group 25",
    "Group 124",
    "Group 125"
  ],

  "U2Innovate Project-6: AI Based Phishing Detection Framework": [
    "Group 26",
    "Group 27",
    "Group 28",
    "Group 29",
    "Group 30",
    "Group 126",
    "Group 127"
  ],

  "Cyber U2UInnovate-Project 7:Threat Intelligence Dashboard": [
    "Group 31",
    "Group 32",
    "Group 33",
    "Group 34",
    "Group 35",
    "Group 128",
    "Group 129"
  ],

  "U2UInnovate-Project 8:Human Factors in Cybersecurity Awareness": [
    "Group 36",
    "Group 37",
    "Group 38",
    "Group 39",
    "Group 40",
    "Group 130",
    "Group 131"
  ],

  "U2Innovate Project-9: Blockchain-Based Academic Certificate Verification": [
    "Group 41",
    "Group 42",
    "Group 43",
    "Group 44",
    "Group 45",
    "Group 132",
    "Group 133"
  ],

  "U2Innovate Project-10: Blockchain for Supply Chain Transparency": [
    "Group 46",
    "Group 47",
    "Group 48",
    "Group 49",
    "Group 50",
    "Group 134",
    "Group 135"
  ],
"U2UInnovate-Project 11:Smart Campus Energy Monitoring System": [
    "Group 51",
    "Group 52",
    "Group 53",
    "Group 54",
    "Group 55",
    "Group 136",
    "Group 137"
  ],

  "U2Innovate Project-12: Air Quality Monitoring and Prediction System": [
    "Group 56",
    "Group 57",
    "Group 58",
    "Group 59",
    "Group 60",
    "Group 138",
    "Group 139"
  ],
 "U2UInnovate-Project 13:Performance Analysis of Cloud Service Models": [
    "Group 61",
    "Group 62",
    "Group 63",
    "Group 64",
    "Group 65",
    "Group 140",
    "Group 141"
  ],
 "U2UInnovate-Project 14:Multi-Cloud Resource Optimization": [
    "Group 66",
    "Group 67",
    "Group 68",
    "Group 69",
    "Group 70",
    "Group 142",
    "Group 143"
  ],
  "U2UInnovate-Project 15:Predictive Analytics for Road Accident Prevention": [
    "Group 71",
    "Group 72",
    "Group 73",
    "Group 74",
    "Group 75",
    "Group 144",
    "Group 145"
  ],

  "U2Innovate Project-16: Social Media Sentiment Analysis": [
    "Group 76",
    "Group 77",
    "Group 78",
    "Group 79",
    "Group 80",
    "Group 146",
    "Group 147"
  ],

  "U2Innovate Project-17: Vision-Based Object Detection for Autonomous Systems": [
     "Group 81",
    "Group 82",
    "Group 83",
    "Group 84",
    "Group 85",
    "Group 148",
    "Group 149"
  ],

  "U2Innovate Project-18: AI-Driven Predictive Maintenance System": [
    "Group 86",
    "Group 87",
    "Group 88",
    "Group 89",
    "Group 90",
    "Group 150",
    "Group 151"
  ],

  "U2Innovate Project-19: Multi-Agent AI System for Academic Assistant": [
   "Group 91",
    "Group 92",
    "Group 93",
    "Group 94",
    "Group 95",
    "Group 152",
    "Group 153"
  ],

  "U2Innovate Project-20: Retrieval-Augmented Generation (RAG)": [
    "Group 96",
    "Group 97",
    "Group 98",
    "Group 99",
    "Group 100",
    "Group 111",
    "Group 112",
    "Group 113",
    "Group 114",
    "Group 115"
  ],

  "U2Innovate Project-21: AI Agent for Cybersecurity Incident Response": [
    "Group 101",
    "Group 102",
    "Group 103",
    "Group 104",
    "Group 105",
    "Group 154",
    "Group 155"
  ],

  "U2Innovate Project-22: Hallucination Detection in Large Language Models": [
    "Group 106",
    "Group 107",
    "Group 108",
    "Group 109",
    "Group 110",
    "Group 156",
    "Group 157"
  ]
};
  const [form, setForm] = useState({
    studentName: "",
    email: "",
    projectTitle: "",
    GroupNumber: "",
    question: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleProjectChange = (e) => {
    const selectedProject = e.target.value;

    setForm({
      ...form,
      projectTitle: selectedProject,
      GroupNumber: "" // reset group when project changes
    });
  };

const handleSubmit = async () => {
  try {
    const formData = new FormData();

    formData.append("studentName", form.studentName);
    formData.append("email", form.email);
    formData.append("projectTitle", form.projectTitle);
    formData.append("GroupNumber", form.GroupNumber);
    formData.append("question", form.question);

    const response = await fetch(`${API_URL}/questions`, {
      method: "POST",
      body: formData
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    setForm({
      studentName: "",
      email: "",
      projectTitle: "",
      GroupNumber: "",
      question: ""
    });

    if (onSubmit) onSubmit();

  } catch (error) {
    console.error("Submission error:", error);
    alert("Failed to submit question. Please try again.");
  }
};
  return (
    <div>
      <h2>Ask Your Question</h2>
<h4>Submit your request to the U2U Platform Support Team</h4>
      {/* PROJECT DROPDOWN */}
      <select
        name="projectTitle"
        value={form.projectTitle}
        onChange={handleProjectChange}
      >
        <option value="">Select Project</option>
        {Object.keys(projectGroupsMap).map((project) => (
          <option key={project} value={project}>
            {project}
          </option>
        ))}
      </select>

      <br />
<br></br>
      {/* GROUP NUMBER DROPDOWN (DEPENDENT) */}
      <select
        name="GroupNumber"
        value={form.GroupNumber}
        onChange={handleChange}
        disabled={!form.projectTitle}
      >
        <option value="">Select Group Number</option>

        {form.projectTitle &&
          projectGroupsMap[form.projectTitle].map((group) => (
            <option key={group} value={group}>
              {group}
            </option>
          ))}
      </select>

      <br />
<input
        name="studentName"
        placeholder="Student Name"
        onChange={handleChange}
        value={form.studentName}
      />
      <input
        name="email"
        placeholder="Email"
        onChange={handleChange}
        value={form.email}
      />
      <br />
      <br />
      <br></br>
<textarea
  name="question"
  placeholder="My request to the U2U Platform Support Team is"
  onChange={handleChange}
  value={form.question}
  rows={4}
  style={{
    width: "100%",
maxWidth: "900px",
    boxSizing: "border-box"
  }}
/>
      <br></br>
     <div style={{ marginTop: "10px" }}>
  
</div> 
      <br />

      <button onClick={handleSubmit}
      style={{
    width: "200px",
    backgroundColor: "green",
    color: "white",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer"
  }}
      >Submit</button>
    </div>
  );
}